import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetUserInfoQuery } from "../redux/api/userInfo";


export const useGetLanguage = () => {
    const { data } = useGetUserInfoQuery();
    const [searchParams] = useSearchParams();
    const { i18n } = useTranslation();

    return data?.language_code ?? searchParams.get('lang') ?? i18n.language ?? "en";
}

export const useGetLanguageId = () => {
    const langCode = useGetLanguage()
    let langId;
    switch (langCode) {
        case "uk":
            langId = 1;
            break;
        case 'en':
            langId = 2;
            break;
        case "ru":
            langId = 3;
            break;
    }

    return langId
}